const route = [
    {
        path: '/siniestros',
        name: 'siniestros',
        meta: { authRequired: true },
        component: () => import('./Siniestros')
    },
    {
        path: '/siniestros-lop/',
        name: 'siniestrosLOP',
        meta: { authRequired: true },
        component: () => import('./Siniestros')
    },
    {
        path: '/siniestros/siniestro-detail',
        name: 'siniestroDetail',
        meta: { authRequired: true },
        component: () => import('./SiniestroDetail')
    },
    {
        path: '/siniestros/siniestro-detailRAC',
        name: 'siniestroDetailRAC',
        meta: { authRequired: true },
        component: () => import('./SiniestroDetail')
    },
];

module.exports = {
    route
};
